//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get, omit, remove, unionBy } from 'lodash'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import hasWindow from '~/mixins/hasWindow'
import hasArticles from '~/mixins/hasArticles'
import Comment from '~/models/Comment'
import ModalConfirm from '~/components/modal/ModalConfirm'
import VerifiedBadge from '~/components/ui/VerifiedBadge'

dayjs.extend(relativeTime)

const commentModel = {
  text: '',
  is_anonymous: false,
}

export default {
  components: { ModalConfirm, VerifiedBadge },
  mixins: [hasArticles, hasWindow],

  async fetch() {
    await this.loadData()
  },

  data() {
    return {
      comments: [],
      meta: {
        current_page: 0,
        last_page: 0,
      },
      totalComment: 0,
      isLoading: false,
      showConfirm: false,
      commentData: {
        comment: { ...commentModel },
        is_anonymous: false,
        commentLoading: false,
        reply: {},
        replyLoading: {},
      },
      selectedComment: null,
    }
  },

  beforeMount() {
    // this.loadData()
  },

  mounted() {
    this.setLastComment()
  },

  methods: {
    async loadData() {
      try {
        this.isLoading = true
        const articleId = this.$route.params.id
        const page = (this.meta && this.meta.current_page + 1) || 1
        const params = {
          orderBy: 'created_at',
          limit: 3,
          page,
        }
        const response = await this.$axios.get(
          `v1/articles/${articleId}/comment`,
          {
            params,
          }
        )

        this.meta = omit(response.data.data, 'data')
        this.totalComment = get(response, 'data.total')
        const comments = get(response.data, 'data.data')
        const items = comments.map((parent) => {
          const newParent = new Comment(parent)
          return newParent
        })
        this.comments = unionBy(this.comments, items, ({ id }) => id)
        this.meta = omit(response.data.data, 'data')
        this.isLoading = false
      } catch (err) {
        this.$alert.requestError(err)
      }
    },
    async loadMore() {
      if (this.meta && this.meta.current_page === this.meta.last_page) {
        return
      }

      await this.loadData()
    },
    async actionReply(comment) {
      const commentId = comment?.id
      try {
        if (commentId) {
          this.commentData.replyLoading[commentId] = true
        } else {
          this.commentData.commentLoading = true
        }

        const articleId = this.$route.params.id
        const bodyParams = {
          article_id: articleId,
          comment: commentId
            ? this.commentData.reply[commentId].text
            : this.commentData.comment.text,
          is_anonymous: commentId
            ? this.commentData.reply[commentId].is_anonymous
            : this.commentData.comment.is_anonymous,
        }
        if (commentId) {
          bodyParams.parent_id = commentId
        }

        const response = await this.$axios.post(`v1/comments`, bodyParams)

        const responseData = get(response, 'data.data')
        const newComment = new Comment(responseData)

        if (!newComment.is_max_comment) {
          this.$modalGetPoint.show()
        }

        if (commentId) {
          const parent = this.comments.find((item) => {
            return item.id === commentId
          })
          if (parent.replies) {
            parent.replies.unshift(newComment)
          } else {
            parent.replies = [newComment]
          }

          this.commentData.reply[commentId].text = ''
        } else {
          this.commentData.comment.text = ''
          this.comments.unshift(newComment)
        }
        this.totalComment += 1
      } catch (err) {
        this.$alert.requestError(err)
      } finally {
        if (commentId) {
          this.commentData.replyLoading[commentId] = false
        } else {
          this.commentData.commentLoading = false
        }
      }
    },
    handleReply(comment) {
      this.$auth.authCheck((isPass) => {
        if (isPass) {
          this.actionReply(comment)
        } else {
          const commentDataString = JSON.stringify(this.commentData)
          this.$router.replace({ query: { comment: commentDataString } })
        }
      })
    },
    showReply(comment) {
      this.commentData.reply[comment.id] = { ...commentModel }
      comment.onReply = true
    },
    hideReply(comment) {
      comment.onReply = false
    },
    getTimeFromNow(date) {
      return dayjs(date).fromNow()
    },
    setLastComment() {
      const commentString = this.$route.query.comment
      if (commentString) {
        const comment = JSON.parse(commentString)
        this.commentData = comment
        this.$router.replace({ query: {} })
        const el = this.$el.getElementsByClassName('text-left')[0]
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' })
        }, 500)
      }
    },
    async handleDelete() {
      try {
        this.isLoading = true
        let childCount = 0
        const parent = this.comments.find(
          (item) => item.id === this.selectedComment.parent_id
        )
        await this.$axios.delete(`v1/comments/${this.selectedComment.id}`)

        if (this.selectedComment.parent_id) {
          remove(parent.replies, (item) => item.id === this.selectedComment.id)
        } else {
          childCount = this?.selectedComment?.replies?.length || 0
          remove(this.comments, (item) => item.id === this.selectedComment.id)
        }

        this.totalComment -= childCount + 1

        if (this.comments.length < 3) {
          this.meta.current_page = 0
          this.meta.last_page = 0
          await this.loadData()
        }
      } catch (err) {
        this.$alert.requestError(err)
      } finally {
        this.isLoading = false
        this.handleCloseConfirm()
      }
    },
    handleShowConfirm(comment) {
      this.selectedComment = comment
      this.showConfirm = true
    },
    handleCloseConfirm() {
      this.selectedComment = null
      this.showConfirm = false
    },
  },
}
